module.exports = __webpack_public_path__ + "public/images/singing.dcc7b7fa38e5409350112609e53c02dd.png";